<template>
  <div class="quality-history-table">
    <table class="woot-table">
      <thead>
        <tr>
          <th>{{ $t('INBOX_MGMT.QUALITY.TABLE.DATE') }}</th>
          <th>{{ $t('INBOX_MGMT.QUALITY.TABLE.TIME') }}</th>
          <th>{{ $t('INBOX_MGMT.QUALITY.TABLE.BRASILIA_DATETIME') }}</th>
          <th>{{ $t('INBOX_MGMT.QUALITY.TABLE.QUALITY') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="record in records" :key="record.id">
          <td>{{ formatDate(record.date) }}</td>
          <td>{{ record.time }}</td>
          <td>{{ formatBrasiliaDateTime(record.date, record.time) }}</td>
          <td
            class="quality-history-table__rating"
            :style="{ color: ratingColor(record.rating) }"
          >
            {{ levelLabel(record.rating) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  LEVEL_LABEL_KEYS,
  RATING_COLORS,
  formatBrasiliaDateTime,
  formatIsoDate,
  normalizeRating,
} from '../helpers/qualityHistory';

export default {
  name: 'QualityHistoryTable',
  props: {
    records: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatDate: formatIsoDate,
    formatBrasiliaDateTime,
    levelLabel(rating) {
      return this.$t(LEVEL_LABEL_KEYS[normalizeRating(rating)]);
    },
    ratingColor(rating) {
      return RATING_COLORS[normalizeRating(rating)];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/variables';

.quality-history-table {
  height: 300px;
  overflow-y: auto;

  .quality-history-table__rating {
    font-weight: var(--font-weight-medium);
  }

  th {
    position: sticky;
    top: 0;
    background: var(--white);
  }
}
</style>
